/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Utils
import { cloneDeep, get, isEmpty, isNil } from 'lodash';

// Components
import CustomActionButton from 'shared/ui/components/form-components/CustomActionButton.vue';
import ExpandableContent from 'shared/ui/components/ExpandableContent.vue';
import FpExtId from 'shared/ui/components/form-components/FpExtId.vue';
import LoaderButton from 'shared/ui/components/form-components/LoaderButton.vue';
import LocaleSelector from 'shared/ui/components/form-components/pickers/LocaleSelector.vue';
import MetaFieldset from 'shared/ui/components/form-components/MetaFieldset.vue';

/**
 * This page is used to handle dynamicly created forms
 */
const __vue_script__ = {
    name: 'MetaForm',

    components: {
        CustomActionButton,
        ExpandableContent,
        FpExtId,
        LoaderButton,
        LocaleSelector,
        MetaFieldset
    },

    props: {
        value: {
            type: Object,
            default: () => ({})
        },

        fields: {
            type: Array,
            default: () => ([])
        },

        showHiddenFields: {
            type: Boolean,
            default: false,
        },

        event: {
            type: Object,
            default: () => ({})
        },

        currentController: {
            type: Object,
            default: () => ({})
        },

        fpType: {
            type: String,
            default: ''
        },

        showToolbar: {
            type: Boolean,
            default: false
        },

        showFpExtId: {
            type: Boolean,
            default: true
        },

        /**
         * This is the trigger for the saving. Changing this value to a non
         * null value will trigger the saving routine.
         */
        saveHook: {
            type: Number,
            default: null
        },

        onlyValidate: {
            type: Boolean,
            default: false
        },

        /**
         * There are form controls that stores some values in the browser store,
         * in order to avoid name clashing we use a `context`.
         * In most cases this coincide with the event ID.
         *
         * An example where we use the context in order to store data is the color
         * picker, where we want to store a palette based on the event ID.
         */
        context: {
            type: String,
            default: null
        },

        /**
         * This component is smart enough to determine if we're editing a record
         * or creating a new one. But in order to have a better control we can use
         * this flag to overwrite the default behaviour.
         */
        edit: {
            type: Boolean,
            default: false
        },

        /**
         * This flag is used to determine if we should hide the language selector
         * in the form.
         */
        hideLanguageSelector: {
            type: Boolean,
            default: false
        },

        /**
         * This flag is used to determine if we should redirect the user to the
         * listing page after the save operation.
         */
        redirectOnSave: {
            type: Boolean,
            default: true
        },

        /**
         * Flag for preventing the component to split the page into two panels.
         */
        singlePanel: {
            type: Boolean,
            default: false
        },

        translationsKey: {
            type: String,
            default: undefined
        }
    },

    data() {
        const buttons = this.currentController.routeOptions?.customActionButtons || [];

        return {
            currentLang: null,
            customActions: Object.keys(buttons).map(k => ({ _name: k, ...buttons[k] })),
            defaultLang: this.event.languages?.[0] || 'en',
            editing: this.edit || this.value?.hasOwnProperty('_id'),
            hasT9n: false,
            innerValue: {},
            saving: false,
            valid: false,
            originalValue: {},
            settings: {},
            metadataModule: this.$services.blueprint?.getModuleByName('metadata'),
            disabled: null,
            categoryBadges: {},
            behaviors: [],
        };
    },

    computed: {
        /** @returns {object[]} */
        fieldsSorted() {
            const visibleFields = this.fields.filter(field => this.isVisible(field));

            if (this.singlePanel) {
                return [this.$utils.controls.sortAndGroupFields(visibleFields, this.$i18n.t('metadata_editor.no_category'), this.editing)];
            }

            const fieldsLeft = this.$utils.controls.fieldsByPlacement(visibleFields, 'left');
            const fieldsRight = this.$utils.controls.fieldsByPlacement(visibleFields, 'right');

            const sortedLeft = this.$utils.controls.sortAndGroupFields(fieldsLeft, this.$i18n.t('metadata_editor.no_category'), this.editing);
            const sortedRight = this.$utils.controls.sortAndGroupFields(fieldsRight, this.$i18n.t('metadata_editor.no_category'), this.editing);

            return [sortedLeft, sortedRight];
        },

        /** @returns {boolean} */
        collapsiblePrimaryFieldsets() {
            return Object.keys(this.primaryFieldsSorted).length > 1;
        },

        /** @returns {boolean} */
        collapsibleSecondaryFieldsets() {
            return Object.keys(this.secondaryFieldsSorted).length > 1;
        },

        /** @returns {boolean} */
        showMetadataButton() {
            if (!this.metadataModule || !this.$services.user.hasPermission(this.metadataModule.permission, { org_id: this.event?.ownerId })) {
                return false;
            }
            return get(this, 'event._id') && !isEmpty(this.fpType);
        },

        isT9nEnabled() {
            return (this.hasT9n || this.translationsKey) && this.event.languages?.length > 1;
        },
    },

    watch: {
        value: {
            handler(value) {
                this.innerValue = cloneDeep(value || {});
                this.originalValue = cloneDeep(value || {});
                this.disabled = this.innerValue.hasOwnProperty('fp_readonly') ? Boolean(this.innerValue.fp_readonly) : null;
                this.editing = this.edit || this.innerValue.hasOwnProperty('_id');
                this.addBehaviours();
            },
            immediate: true
        },

        saveHook(value) {
            if (value) {
                this.save();
            }
        }
    },

    async created() {
        try {
            this.hasT9n = await this.$services.metadata.isFpTypeTranslatable(this.event._id, this.fpType);
            if (this.isT9nEnabled) {
                this.currentLang = this.defaultLang;
            }

            if (this.event?._id && this.$services.settings) {
                this.settings = await this.$services.settings.getSettings(this.event._id);
            }
        } catch (error) {
            console.error('[MetaForm] Error fetching settings', error.message);
            this.settings = {};
        }

        window.addEventListener('set-form-category-badge', this.onSetCategoryBadge);
    },

    destroyed() {
        window.removeEventListener('set-form-category-badge', this.onSetCategoryBadge);
    },

    methods: {
        /**
         * Check if a field is visible or not
         * @param field
         */
        isVisible(field) {
            if (
                (field.hidden && !field.app_hidden)
                || this.$services.user.isInvitedByLink(this.event) && field.hideForInvited
            ) {
                return false;
            }
            const settingsCond = field.conditions?.settings;
            if (Array.isArray(settingsCond)) {
                let visible = false;
                for (const { path, value } of settingsCond) {
                    visible = get(this.settings, path) === value;
                    if (!visible) {
                        break;
                    }
                }
                return visible;
            }
            return true;
        },

        /**
         * Returns the href for the metadata editor.
         *
         * @returns {string} The href for the metadata editor.
         */
        getMetadataEditorHref() {
            return this.$utils.modules.getRouteHref(this.metadataModule, 'default', {
                type: this.fpType,
                eventId: this.event._id
            }, (routes) => routes.find(r => r.match(/:type/)));
        },

        /**
         * Resets the form model
         */
        reset() {
            const newInnerValue = {};
            for (const fd of this.fields) {
                newInnerValue[fd.field] = null;
            }
            this.innerValue = newInnerValue;
        },

        /**
         * Checks form validity
         *
         * @returns {Promise.<Boolean>} the form validity
         */
        async validate() {
            const validForm = !this.$refs.form ? true : await this.$refs.form.validate();

            this.valid = validForm;

            if (this.valid) {
                this.$emit('valid', this.innerValue);
            }

            console.info('[MetaForm] Validity:', this.valid, this.innerValue);

            return this.valid;
        },

        /**
         * Saves the model remotely
         *
         * @param {MetaFormFlags} [customFlags] - The saving process configuration.
         *
         * @returns {Promise<Object>} the server response
         */
        async save(customFlags) {
            try {
                if (this.saving) {
                    return;
                }

                this.saving = true;

                if (!await this.validate()) {
                    this.$emit('error');
                    return;
                }

                if (this.onlyValidate) {
                    return;
                }

                console.debug('[MetaForm] %s the document', this.editing ? 'Updating' : 'Creating');

                let outcome = null;
                if (this.editing) {
                    outcome = await this.update();
                } else {
                    outcome = await this.create();
                }

                this.$emit('saved', this.innerValue);
                this.$refs.form.reset();

                this.$notify({
                    group: 'flashes',
                    text: customFlags?.savedMessage || this.$i18n.t('generic_form.messages.created').toString()
                });

                const { saved, post } = outcome;
                this.handleRedirect(customFlags, saved, post);
            } catch (error) {
                this.handleSaveError(error);
            } finally {
                this.saving = false;
            }
        },

        /**
         * Retrieves the saving options for the form.
         *
         * @returns {Object} The saving options object.
         */
        async getSavingOptions() {
            const { _id, node } = this.event;
            const metadataForType = await this.$services.metadata.getMetadataForTypeAsArray(_id, this.fpType);
            const fieldsToFillIfEmpty = this.$utils.metadata.findFieldsWithFlag(metadataForType, 'generate_value_if_empty');
            const options = { fieldsToFillIfEmpty, include_upserted_doc_ids: true };

            return { eid: _id, node, options };
        },

        /**
         * Creates a new record
         *
         * @returns {Promise<{ saved: any, post: any }>} The result of the create operation.
         *
         * @throws {Error}
         */
        async create() {
            const { eid, node, options } = await this.getSavingOptions();
            const { data } = await this.$services.documents.createDocs(eid, node, this.fpType, this.$utils.controls.sanitizeForm(this.innerValue), options);

            this.$set(this.innerValue, '_id', data.upsertedDocIds[0]);

            if (typeof this.innerValue.afterSave === 'function') {
                this.innerValue.afterSave();
            }

            const postProcessResult = await this.postProcess(data);

            if (await this.$services.backlinks?.isBacklinksSearchAvailable(eid)) {
                await this.$services.backlinks.triggerAndWaitForBacklinksRefresh(eid);
            }

            return { saved: data, post: postProcessResult };
        },

        /**
         * Updates an existing record
         *
         * @returns {Promise<{ saved: any, post: any }>} The result of the update operation.
         *
         * @throws {Error}
         */
        async update() {
            const { eid, node, options } = await this.getSavingOptions();

            let ignoreProtectedFields;

            if (this.$services.documents.doProtectedFieldsDiffer(this.originalValue, this.innerValue)) {
                ignoreProtectedFields = options.ignoreProtected = confirm(
                    'You have made changes in protected fields. ' +
                    'These data were set by the user. Overwrite these?'
                );
            }

            if (typeof this.innerValue.beforeSave === 'function') {
                await this.innerValue.beforeSave();
            }

            const { data } = await this.$services.documents.updateDoc(eid, node, this.fpType, this.$utils.controls.sanitizeForm(this.innerValue), options);

            if (typeof this.innerValue.afterSave === 'function') {
                this.innerValue.afterSave();
            }

            const postProcessResult = await this.postProcess(data);

            // take care of our view of protected field value state
            if (this.originalValue.fp_protected) {
                this.originalValue.fp_protected.forEach(field => {
                    if (ignoreProtectedFields) { // update original model with new protected field values
                        this.$set(this.originalValue, field, this.innerValue[field]);
                    } else { // restore values back to their originals
                        this.$set(this.innerValue, field, this.originalValue[field]);
                    }
                });
            }

            return { saved: data, post: postProcessResult };
        },

        /**
         * This method is used to call the `onAfterModelSaveAppScript` app script
         */
        async postProcess(data) {
            const postScript = get(this, 'currentController.routeOptions.onAfterModelSaveAppScript');
            if (!postScript) {
                return null;
            }

            const conditions = get(this, 'currentController.routeOptions.afterSaveConditions', null);
            let execute = isNil(conditions);
            if (conditions) {
                execute = this.$utils.objects.areConditionsMet(conditions, this.innerValue);

                if (!execute) {
                    console.info('[MetaForm] Conditions for post process script are not met', conditions);
                }
            }

            if (!execute) {
                return null;
            }

            console.warn('[MetaForm] Calling post process script on the FE is deprecated. Please refactor the package!', postScript);
            const params = {
                model_id: !isEmpty(data.upsertedDocIds) ? data.upsertedDocIds[0] : this.innerValue._id,
                changed: !isEmpty(data.upsertedDocIds)
            };

            const scriptParams = get(this, 'currentController.routeOptions.afterSaveParams', {});
            for (const key of Object.keys(scriptParams)) {
                let value = this.innerValue[scriptParams[key]] || scriptParams[key];
                if (value === '*') {
                    value = this.innerValue;
                }
                params[key] = value;
            }

            return await this.$services.appScripts.callAppScript(this.event._id, postScript, params);
        },

        /**
         * Handles the redirection logic after form submission.
         *
         * @param {Object} customFlags - Custom flags that may influence the redirection logic.
         * @param {Object} saveResult - The result of the save operation.
         * @param {Object} postProcessResult - The result of the save operation.
         */
        handleRedirect(customFlags, saveResult, postProcessResult) {
            if (customFlags?.preventRedirect || !this.redirectOnSave) {
                console.debug('[MetaForm] Redirect after save is disabled.');
                return;
            }

            const routeParams = { eventId: this.event._id, fpType: this.fpType, ...this.innerValue };
            if (postProcessResult) {
                Object.assign(routeParams, { ...postProcessResult });
            } else {
                const id = saveResult.upsertedDocIds[0];
                Object.assign(routeParams, { id, _id: id });
            }

            if (typeof this.$router.resolve === 'function') {
                // Vue router
                this.redirect(routeParams);
            } else {
                // Blueprint based routing
                this.legacyRedirect(routeParams);
            }
        },

        /**
         * Handles legacy redirects based on the provided route parameters.
         *
         * @param {Object} routeParams - The parameters from the route.
         */
        legacyRedirect(routeParams) {
            const customRedirect = get(this, 'currentController.routeOptions.afterSaveRedirectRoute', null);
            const redirectConditions = get(this, 'currentController.routeOptions.afterSaveRedirectConditions', null);
            let followRedirect = isNil(redirectConditions);

            if (redirectConditions) {
                followRedirect = this.$utils.objects.areConditionsMet(redirectConditions, this.innerValue);
            }

            const route = (followRedirect && customRedirect) || this.editing ? customRedirect : this.$services.blueprint?.getFpTypeListingPath(this.event._id, this.fpType);

            if (!route) {
                console.debug('[MetaForm] No redirect.', { eid: this.event._id, fpType: this.fpType });
                return;
            }

            const normalizedRoute = this.$utils.modules.normalizeRoute(route);
            const path = this.$utils.url.interpolateUrl(normalizedRoute, routeParams);

            this.$router.push(path);
        },

        /**
         * Redirects to a new route based on the provided route parameters.
         *
         * @param {Object} routeParams - The parameters to use for the redirection.
         */
        redirect(routeParams) {
            const redirectName = this.$route.meta?.redirect;
            if (!redirectName) {
                console.debug('[MetaForm] No redirect defined.');
                return;
            }

            const conditions = get(this.$route, 'meta.redirect_conditions', null);

            if (conditions && !this.$utils.objects.areConditionsMet(conditions, this.innerValue)) {
                console.warn('[MetaForm] Conditions for redirect are not met', conditions);
                return;
            }

            const { resolved } = this.$router.resolve({ name: redirectName, params: routeParams });
            this.$router.push(resolved);
        },

        /**
         * Handles the error that occurs during the save operation.
         *
         * @param {Error} error - The error object that contains details about the save error.
         */
        handleSaveError(error) {
            let { field, detail } = this.$utils.net.parseServerError(error);

            if (this.$te(detail)) {
                detail = this.$t(detail);
            }

            if (field) {
                this.$refs.form.setErrors({ [field]: [detail] });
            }

            this.$emit('error', error, field, detail);

            this.$notify({
                group: 'flashes',
                text: detail,
                type: 'error'
            });
        },

        /**
         * This handler is used to update the revision of the
         * current model
         *
         * @param {string} rev the new rev
         */
        revUpdate(rev) {
            console.info('[MetaForm] New rev update received', rev);
            if (this.innerValue._rev !== rev) {
                this.$set(this.innerValue, '_rev', rev);
            }
        },

        /**
         * This handler is used to add a new behaviour to the
         * current model.
         *
         * Currently supported: `afterSave` => function
         *
         * @param {{'afterSave': function}} behaviours an array of new behaviours
         */
        addBehaviours(behaviours) {
            console.info('[MetaForm] New behaviour received', behaviours);
            this.behaviours = { ...this.behaviours, ...behaviours };
            for (const behaviour of Object.keys(this.behaviours)) {
                if (typeof this.behaviours[behaviour] === 'function') {
                    this.$set(this.innerValue, behaviour, this.behaviours[behaviour]);
                }
            }
        },

        /**
         * Handles the input for multi-value fields.
         * This is a special case for Angular JS components
         * that can emit more than just a single field value.
         *
         * @param {string} field - The field name.
         * @param {any} value - The input value.
         */
        handleMultiInput(field, value) {
            this.$set(this.innerValue, field, value);
        },

        onDisable(disabled) {
            this.disabled = disabled;
        },

        onReload() {
            this.$emit('reload');
        },

        /**
         * Save event handler
         *
         * @param customFlags.preventRedirect {boolean} - Prevent redirect after save
         */
        onSave(customFlags) {
            this.save(customFlags);
        },

        isDirty() {
            return this.$refs.form?.flags?.dirty;
        },

        setErrors(errorsObject) {
            this.$refs.form?.setErrors(errorsObject);
        },

        getBadge(category) {
            return this.categoryBadges[category];
        },

        onSetCategoryBadge(e) {
            const { inputName, label } = e.detail || {};
            const { category } = this.fields.find(d => d.name && d.name === inputName) || {};
            if (category && label) {
                // `this.categoryBadges[category] = label` does not trigger a re-evaluation of getBadge above
                this.$set(this.categoryBadges, category, label);
            }
        },
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('validation-observer',{ref:"form",staticClass:"meta-form",attrs:{"tag":"form"},on:{"submit":function($event){$event.preventDefault();return _vm.save()}}},[_c('div',{staticClass:"inner-form",class:{ 'panels panels-b2': !_vm.singlePanel }},[_vm._l((_vm.fieldsSorted),function(fieldSorted,panelIndex){return [_c('div',{staticClass:"panel"},[(panelIndex === 0)?_vm._t("primary-panel-top"):_vm._e(),(panelIndex === 0)?[(!_vm.hideLanguageSelector && _vm.isT9nEnabled)?_c('locale-selector',{attrs:{"event":_vm.event,"label":_vm.$t('general.forms.labels.locale'),"tip":_vm.fpType ? _vm.$t('generic_form.types.locale_tip') : null,"hint":_vm.fpType ? _vm.$t('generic_form.types.locale_hint') : null},model:{value:(_vm.currentLang),callback:function ($$v) {_vm.currentLang=$$v},expression:"currentLang"}}):_vm._e()]:_vm._e(),(panelIndex === 1)?[(_vm.showFpExtId)?_c('fp-ext-id',{attrs:{"doc":_vm.innerValue,"controller":_vm.currentController}}):_vm._e(),_vm._t("secondary-panel-top")]:_vm._e(),(Object.keys(fieldSorted).length > 1)?[_vm._l((fieldSorted),function(fieldset,legend){return [(legend.startsWith('_no_category_'))?[_c('meta-fieldset',{key:legend,attrs:{"context":_vm.context,"disabled":_vm.disabled,"edit":_vm.editing,"event":_vm.event,"fieldset":fieldset,"show-hidden-fields":_vm.showHiddenFields,"locale":_vm.currentLang,"settings":_vm.settings,"is-translatable":_vm.hasT9n,"translations-key":_vm.translationsKey},on:{"behaviour":_vm.addBehaviours,"disable":_vm.onDisable,"locale-change":function (locale) { return _vm.currentLang = locale; },"multi-input":_vm.handleMultiInput,"reload":_vm.onReload,"rev":_vm.revUpdate,"save":_vm.onSave},model:{value:(_vm.innerValue),callback:function ($$v) {_vm.innerValue=$$v},expression:"innerValue"}})]:[_c('expandable-content',{key:legend,staticClass:"fieldset",attrs:{"clickable-header":true,"is-open":true,"limit-height":false,"unlimited-height":true,"hide-if-no-children":true},scopedSlots:_vm._u([{key:"header",fn:function(ref){return [_c('h5',[_c('span',[_vm._v(_vm._s(legend))]),(_vm.getBadge(legend))?_c('div',{staticClass:"badge"},[_vm._v(_vm._s(_vm.getBadge(legend)))]):_vm._e()])]}}],null,true)},[_c('meta-fieldset',{attrs:{"context":_vm.context,"disabled":_vm.disabled,"edit":_vm.editing,"event":_vm.event,"fieldset":fieldset,"show-hidden-fields":_vm.showHiddenFields,"locale":_vm.currentLang,"settings":_vm.settings,"is-translatable":_vm.hasT9n,"translations-key":_vm.translationsKey},on:{"behaviour":_vm.addBehaviours,"disable":_vm.onDisable,"locale-change":function (locale) { return _vm.currentLang = locale; },"multi-input":_vm.handleMultiInput,"reload":_vm.onReload,"rev":_vm.revUpdate,"save":_vm.onSave},model:{value:(_vm.innerValue),callback:function ($$v) {_vm.innerValue=$$v},expression:"innerValue"}})],1)]]})]:_vm._l((fieldSorted),function(fieldset,legend){return _c('meta-fieldset',{key:legend,attrs:{"context":_vm.context,"disabled":_vm.disabled,"edit":_vm.editing,"event":_vm.event,"fieldset":fieldset,"show-hidden-fields":_vm.showHiddenFields,"locale":_vm.currentLang,"settings":_vm.settings,"is-translatable":_vm.hasT9n,"translations-key":_vm.translationsKey},on:{"behaviour":_vm.addBehaviours,"disable":_vm.onDisable,"locale-change":function (locale) { return _vm.currentLang = locale; },"multi-input":_vm.handleMultiInput,"reload":_vm.onReload,"rev":_vm.revUpdate,"save":_vm.onSave},model:{value:(_vm.innerValue),callback:function ($$v) {_vm.innerValue=$$v},expression:"innerValue"}})})],2)]})],2),(_vm.showToolbar)?_c('secondary-toolbar',{scopedSlots:_vm._u([{key:"contextual",fn:function(ref){return [(_vm.showMetadataButton)?_c('a',{staticClass:"btn btn-icon",attrs:{"href":_vm.getMetadataEditorHref(),"target":"_blank","rel":"noopener noreferrer"}},[_c('i',{staticClass:"icon-cog"}),_vm._v(" "+_vm._s(_vm.$t('generic_form.types.meta_edit')))]):_vm._e(),_vm._l((_vm.customActions),function(action){return _c('custom-action-button',{attrs:{"event":_vm.event,"action":action,"context":_vm.innerValue,"locale":_vm.currentLang},on:{"change":function($event){return _vm.$emit('saved')}}})}),_vm._t("contextual")]}}],null,true)},[_c('loader-button',{staticClass:"btn btn-primary",attrs:{"disabled":_vm.disabled || _vm.saving,"status":_vm.saving},on:{"click":function($event){$event.preventDefault();return _vm.save()}}},[_vm._v(_vm._s(_vm.$t('general.save')))])],1):_vm._e()],1)}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "MetaForm.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__